import { render, staticRenderFns } from "./RegistrationByMatchCard.vue?vue&type=template&id=2ce93cd5&"
import script from "./RegistrationByMatchCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationByMatchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports